import React from 'react'
import { Button, Flex, Link, Text, useModal } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import BoostFarmModal from 'views/Farms/components/BoostFarmModal'

interface FarmCardActionsProps {
  farmId: number
  boostMultiplier?: number
}

const BoostAnotherAction: React.FC<FarmCardActionsProps> = ({ farmId, boostMultiplier = 1 }) => {
  const { t } = useTranslation()
  const [onPresentBoostFarmModal] = useModal(<BoostFarmModal currentFarmId={farmId} />)

  const clickButton = async () => {
    onPresentBoostFarmModal()
  }

  return (
    <Flex mb="8px" justifyContent="space-between" alignItems="start">
      <Flex flexDirection="column" mt="6px">
        <Text fontSize="18px" bold>
          {boostMultiplier}x
        </Text>
        <Link href="/xvvs/vault" display="inline">
          +/- {t('Boost')}
        </Link>
      </Flex>
      <Button onClick={clickButton}>{t('Boost Another')}</Button>
    </Flex>
  )
}

export default BoostAnotherAction
